import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { CreateBusinessHoursRequest, ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, businessHoursKeys, toast } from '@petseo/shared';
import { usertourService } from '@/services/usertour.service';

export const useCreateBusinessHours = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ serviceVendorId, data }: { serviceVendorId: ServiceVendorId; data: CreateBusinessHoursRequest }) => {
      const response = await serviceVendorsClient.postBusinessHoursEndpoint(data, serviceVendorId);
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, data }) => {
      queryClient.invalidateQueries({ queryKey: businessHoursKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.BUSINESS_HOURS_CREATED);
      usertourService.track('business_hours_configured', { ...data });
    },
    onError: () => toast.error(TOAST_MESSAGES.BUSINESS_HOURS_CREATE_ERROR),
  });
};
